import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { toggleChat } from 'actions/chatAction';

import amplitude from 'amplitude-js';

import { BLOCK_GUIDANCE_SCREEN_SHOWN, CONTACT_SUPPORT_CLICKED } from '../../../../constants/amplitude/AmplitudeEvents';
import { FROM } from '../../../../constants/amplitude/AmplitudeParamName';
import { FRAUD_HARD_BLOCK, FRAUD_SOFT_BLOCK } from '../../../../constants/amplitude/AmplitudeParamValues';
import { FRAUD_BLOCK_INFO_MODAL } from '../../../../constants/ComponentNames';
import { SOFT_BLOCK } from '../../../../constants/Constants';
import { usePageMessages } from '../../../../hooks/selectors';
import { Button } from '../../../common/Button/Button';
import { FixedBottomPanel } from '../../../common/Layout/FixedBottomPanel/FixedBottomPanel';
import ModalComponent from '../../../utils/ModalComponent';

const FraudBlockDisclaimer = (props) => {
    const { fraudBlockDisclaimerText, fraudBlockDisclaimerText2, morePopupChatTitle } = usePageMessages();

    useEffect(() => {
        const blockType = props.errorType === SOFT_BLOCK ? FRAUD_SOFT_BLOCK : FRAUD_HARD_BLOCK;
        amplitude.getInstance().logEvent(BLOCK_GUIDANCE_SCREEN_SHOWN, {
            [FROM]: blockType,
        });
    }, []);

    const getText = () => {
        return (props.error.errorCode === 616 || props.error.errorCode === 642) && !props.isUsaUser ? fraudBlockDisclaimerText2 : fraudBlockDisclaimerText;
    };

    return (
        <ModalComponent
            hasBottomPanel
            onCloseIconClick={() => {
                props.setModal(FRAUD_BLOCK_INFO_MODAL);
            }}
        >
            <article className="maincopy break_words first" id="disclaimer" dangerouslySetInnerHTML={{ __html: getText() }} />
            <FixedBottomPanel isRightAligned>
                <Button
                    type="button"
                    raised={true}
                    caption={morePopupChatTitle}
                    onClick={() => {
                        amplitude.getInstance().logEvent(CONTACT_SUPPORT_CLICKED);
                        props.toggleChat(true);
                    }}
                />
            </FixedBottomPanel>
        </ModalComponent>
    );
};

export default connect(null, { toggleChat })(FraudBlockDisclaimer);
